import React from "react";
import ReportEditor from '../reportEditor/ReportEditorConnector';
import PropTypes from 'prop-types';
import SovosRaisedButton from "s1-ui/sovos-raised-button/SovosRaisedButton";
import SovosButtonsGroup from "s1-ui/sovos-buttons-group/SovosButtonsGroup";
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

const initialState = {
  openReportEditorSlidingPanel: false,
  generateReportDisabled: true,
  cancelReportEdition: false,
  reportInformation: {
    reportId: '',
    reportName: '',
    period: '',
    periodId: '',
    endPeriodId: '',
    createdBy: '',
    creationDate: '',
    extension: '',
    delimiter: ''
  }
};

class ReportEditorContainer extends React.Component {
  state = {
    ...initialState,
    generateReportDisabled: true,
    reportInformation: { ...initialState.reportInformation }
  };

  handleGenerateReport = () => {
    const pageState = this.props.pageState;
    const reportInformation = this.state.reportInformation;
    this.props.reportsActions.generateReport(reportInformation, pageState);
    this.setState( { openReportEditorSlidingPanel: false, generateReportDisabled: true, reportInformation: initialState.reportInformation });
  };

  isGenerateReportDisabled = state => (
    state.reportId === '' ||
    state.periodId === '' ||
    state.endPeriodId === '' ||
    parseInt(state.endPeriodId) < parseInt(state.periodId) ||
    state.extension === '' ||
    (state.extension !== 'xlsx' && state.extension !== 'csv' && state.delimiter === '')
  );

  handleReportTemplateChange = report => {
    const reportInformation = {
      ...this.state.reportInformation,
      reportId: report.id,
      periodId: report.periodId,
      endPeriodId: report.endPeriodId,
      extension: report.format !== 'Custom' ? report.format : report.extension,
      delimiter: report.format !== 'Custom' ? '' : report.delimiter
    };

    this.setState({ reportInformation, generateReportDisabled: this.isGenerateReportDisabled(reportInformation) });
  };

  render() {
    return (
      <div>
        <SovosButtonsGroup
          align="right"
          style={ { marginTop: 25, marginBottom: 15 } }
        >
          <SovosRaisedButton
            onClick={ () => this.setState({ openReportEditorSlidingPanel: true }) }
            disabled={ this.props.generatingReport }
          >
            NEW
          </SovosRaisedButton>
        </SovosButtonsGroup>
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          open={ this.state.openReportEditorSlidingPanel }
          onClose={ () => this.setState({ ...initialState }) }
          showCloseButton={ false }
          baseWidth={ '450px' }
          title={ `New Report` }
          dialogTitle={ SLIDING_PANEL_DIALOG_TITLE }
          dialogText={ SLIDING_PANEL_DIALOG_TEXT }
          dialogContentClassName={ SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME }
          dialogActionLabel={ SLIDING_PANEL_DIALOG_ACTION_LABEL }
          SaveButtonProps={ {
            onClick: this.handleGenerateReport,
            disabled: this.state.generateReportDisabled || this.props.generatingReport,
            className: 'report-editor__button',
            children: 'GENERATE'
          } }
          CancelButtonProps={ {
            className: 'report-editor__button',
            children: 'CANCEL'
          } }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <ReportEditor onReportsTemplatesChange={ this.handleReportTemplateChange } />
        </SovosEditableSlidingPanel>

      </div>
    );
  }
}

ReportEditorContainer.propTypes = {
  generatingReport: PropTypes.bool,
  pageState: PropTypes.object,
  reportsActions: PropTypes.shape(
    {
      generateReport: PropTypes.func.isRequired,
    }
  )
};

export default ReportEditorContainer;



// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportEditorContainer/ReportEditorContainer.js